export class BaseEnvironment {
  /**
   * Adobe SDK path
   *
   */
  adobeSDK =
    "https://assets.adobedtm.com/0a9348ad03c2/c7e2a344c6e9/launch-f2b090ffdcc1-development.min.js";
  /**
   * Channel ID
   *
   */
  channelId = 48;

  /**
   * Default api protocol
   *
   */
  protocol: "http" | "https" = "https";

  /**
   * Disable logging by default
   *
   */
  logging = false;

  /**
   * Disable sending headers
   *
   */
  disabledHeaders = false;

  /**
   * Key for cookie notice consent
   *
   */
  cookieNoticeName = "wmCookieNotice";

  /**
   * Hot deal image path on LOCAL environment
   *
   */
  hotDealImage = "https://image.webmotors.com.br/feiroes/imagens/hml/_portal/";

  /**
   * Cookie Save last search and Last DA
   *
   */
  lastSearchCookieName = "WMLastFilterSearch";

  /**
   * Cookie Save last searches
   *
   */
  lastSearchesCookieName = "WebMotorsLastSearches";

  /**
   * Crypto secret
   *
   */
  secretKey = "twY2NMFSKMskM8NteG9bwBkx";

  /**
   * Data form cookie name
   *
   */
  formDataCookieName = "WebMotorsDataForm";

  /**
   * Geolocation cookie name
   *
   */
  geolocationCookieName = "WebMotorsLocation";

  /**
   * Cookie search segment key
   *
   */
  cookieSearchSegmentKey = "WebMotorsVehicleType";

  /**
   * Indicates if the environment is server side
   *
   * @returns
   */
  isServerSide(): boolean {
    return globalThis.window === undefined;
  }
}
